export const GET_OUTLET_REQUEST = '@@outlets/GET_OUTLET_REQUEST';
export const GET_OUTLET_REQUEST_SUCCESS = '@@outlets/GET_OUTLET_REQUEST_SUCCESS';

export const CREATE_CALLING_WAITRESS_REQUEST = '@@outlets/CREATE_CALLING_WAITRESS_REQUEST';
export const CREATE_CALLING_WAITRESS_REQUEST_SUCCESS = '@@outlets/CREATE_CALLING_WAITRESS_REQUEST_SUCCESS';

export const CREATE_OUTLET_FEED_BACK = '@@outlets/CREATE_OUTLET_FEED_BACK';
export const CREATE_OUTLET_FEED_BACK_SUCCESS = '@@outlets/CREATE_OUTLET_FEED_BACK_SUCCESS';
